export * from './ProductDetailsContentBlock';
